import {
  Container,
  Link,
  makeStyles,
  Toolbar,
  Typography,
} from '@material-ui/core';
import React from 'react';
import GitHubIcon from '../../../public/icons/github.png';
import LinkedInIcon from '../../../public/icons/linkedIn.png';
import SlackIcon from '../../../public/icons/slack.png';
import XIcon from '../../../public/icons/x.svg';
import { LinkImageButton } from './LinkImageButton';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  container: {
    position: 'absolute',
    bottom: 16,
  },
  text: {
    padding: theme.spacing(1),
    // Muted ink on the Eclipse backdrop (kit caption tier)
    color: 'var(--eclipse-100)',
    fontSize: 'var(--text-caption)',
    lineHeight: 'var(--text-caption--line-height)',
  },
}));


export default function Footer() {
  const classes = useStyles();
  const iconWidth = '40%';

  return (
    <Container component="main" className={classes.root}>
      <Toolbar className={classes.container}>
        <LinkImageButton
          href="https://github.com/JupiterOne"
          imageUrl={GitHubIcon}
          width={iconWidth}
        />
        <LinkImageButton
          href="https://www.linkedin.com/company/jupiterone/"
          imageUrl={LinkedInIcon}
          width={iconWidth}
        />
        <LinkImageButton
          href="https://x.com/jupiterone"
          imageUrl={XIcon}
          width={iconWidth}
        />
        <LinkImageButton
          href="https://app.slack.com/client/TJBH82C56/CJ03CAL11"
          imageUrl={SlackIcon}
          width={iconWidth}
        />
        <Link href="https://jupiterone.com/terms/" className={classes.text}>
          <Typography className={classes.text} variant="body1" color="inherit">
            Terms
          </Typography>
        </Link>
        <Typography className={classes.text} variant="body1" color="inherit">
          —
        </Typography>
        <Link
          href="https://jupiterone.com/privacy-policy/"
          className={classes.text}
        >
          <Typography className={classes.text} variant="body1" color="inherit">
            Privacy Policy
          </Typography>
        </Link>
        <Typography className={classes.text} variant="body1" color="inherit">
          —
        </Typography>
        <Link
          href="https://www.jupiterone.com/legal-and-security-hub/"
          className={classes.text}
        >
          <Typography className={classes.text} variant="body1" color="inherit">
            Trust and Transparency
          </Typography>
        </Link>
        <Typography className={classes.text} variant="body1" color="inherit">
          —
        </Typography>
        <Link href="https://jupiterone.com/sbom/" className={classes.text}>
          <Typography className={classes.text} variant="body1" color="inherit">
            Software Bill of Materials
          </Typography>
        </Link>
      </Toolbar>
    </Container>
  );
}
